var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('SubHeaderBlock'),_c('Spinner',{attrs:{"is-loading":_vm.spinnerShow}}),_c('div',{staticClass:"home-block container"},[_c('ActiveOrdersBlock',{on:{"spinner":function($event){_vm.spinnerShow = false}}}),_c('CalendarBlock'),_c('FaultsBlock'),_c('NotificationsBlock')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }